import {PatientCommandParams} from "./PatientCommandParams";
import {Command} from "./Command";
import {NCZIAddress} from "../Interfaces/ncziPatientInformations";
import {NCZIExtension, NCZIReference} from "../Interfaces/ncziTypes";

export type WritePatientSummaryContactInformationParams = PatientCommandParams & {
    patientInformation?: {
        note?: string
        email?: string
        phone?: string
        address?: NCZIAddress
    },
    contactPersons?: {
        recordId?: string
        firstName: string
        lastName: string
        note?: string
        email?: string
        phone?: string
        type: NCZIReference
    }[],
    preferredHealthProfessionals?: {
        recordId?: string
        healthProfessionalId: NCZIExtension
        firstName: string
        lastName: string
        note?: string
        address?: NCZIAddress
    }[]
};

export const WritePatientSummaryContactInformation = (params: WritePatientSummaryContactInformationParams): Command => {
    return {
        operation: 'ZapisPacientskehoSumaruKontaktneUdaje_v4',
        params
    }
}